<script setup lang="ts">
import { toRefs } from 'vue';
import { EMIT } from '@/enum';
import { useTenantIntegrationStore } from '@/store';

const tenantIntegrationStore = useTenantIntegrationStore();

interface PropsInterface {
  data?: null;
  integration?: null;
  tenantId: number | null;
}

const props = withDefaults(defineProps<PropsInterface>(), {
  data: null,
  integration: null,
  tenantId: null,
});

const { data, integration, tenantId } = toRefs(props);

const emit = defineEmits([EMIT.UPDATE]);

const createMenuModel = (item) => {
  return [
    {
      label: 'Sync Data',
      icon: {
        name: 'sync',
        styles: 'inline-block text-lg',
      },
      styles: '',
      command: () => onSync(item.id),
    },
    {
      label: 'Edit Connection',
      icon: {
        name: 'person',
        styles: 'inline-block text-lg',
      },
      styles: '',
      command: () => onEdit(item.id),
    },
    {
      label: 'Remove Connection',
      icon: {
        name: 'vpn_key',
        styles: 'inline-block text-lg',
      },
      command: () => onRemove(item.id),
    },
  ];
};

const onSync = () => emit(EMIT.SYNC);

const onEdit = (id: number) => emit(EMIT.UPDATE, id);

const onRemove = (id: number) => {
  tenantIntegrationStore.deleteTenantIntegrationOrganization(tenantId.value, integration.value.id, id);
};
</script>

<template>
  <div>
    <ActionMenu :menu-items="createMenuModel(data)" icon="more_horiz" />
  </div>
</template>
